import { RootState } from '../../reducers'

export function isOpenAddStepMenu(state: RootState): boolean {
  return !!getPathOfOpenAddStepMenu(state)
}

export function getPathOfOpenAddStepMenu(state: RootState) {
  return state?.stepCreationMenu?.openMenuPath
}

export function isAddStepMenuOpenForPath(state: RootState, path: string) {
  return getPathOfOpenAddStepMenu(state) === path
}
